import React from 'react'
import {AssayInput} from "../components/AssayRequest";
import util from "../lib/chart_functions";
import i18n from "i18next";
import LoadingSpinner from "../components/LoadingSpinner";
import ErrorMessage from "../components/ErrorMessage";
import Accordion from "../components/Accordion";
import { FiDatabase } from 'react-icons/fi';
export default class AssayContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            response: '[]',
            status_code: 200,
            isLoading: true,
            isInitialLoad: true,
            selector_names: ['sex_list', 'type_list', 'organization_list', 'collection_list'],
            headers: ["type_pie", "org_pie", "sex_pie", "age_hist"],
            fields: ["type", "organization", "sex", "age"],
            functions: [util.make_pie_from_json_dict, util.make_pie_from_json_dict, util.make_pie_from_json_dict, util.make_hist_from_json_dict],
            lists: [],
            checkeds: [],
            // Available items based on current selection (from /filters/ endpoint)
            availableOrganizations: new Set(),
            availableCollections: new Set(),
            availableTypes: new Set(),
            availableSex: new Set()
        };
    }

    // Fetch available filter options from /filters/ endpoint
    // Full many-to-many dependencies: all filters affect each other
    fetchAvailableFilters = (filterState) => {
        const selectedOrg = filterState.organization
            .filter((_, i) => filterState.organization_checked[i]);
        const selectedCol = filterState.collection
            .filter((_, i) => filterState.collection_checked[i]);
        const selectedType = filterState.type
            .filter((_, i) => filterState.type_checked[i]);
        const selectedSex = filterState.sex
            .filter((_, i) => filterState.sex_checked[i]);

        const age_na = filterState.age_settings
            .filter((_, i) => filterState.age_settings_checked[i])
            .includes('age_na');
        const age_nb = filterState.age_settings
            .filter((_, i) => filterState.age_settings_checked[i])
            .includes('age_nb');

        const params = new URLSearchParams({
            age_min: filterState.age[0],
            age_max: filterState.age[1],
            age_na: age_na,
            age_nb: age_nb
        });

        // If any main filter is empty, all dependent filters should be empty (no results possible)
        if (selectedOrg.length === 0 || selectedCol.length === 0 ||
            selectedType.length === 0 || selectedSex.length === 0) {
            this.setState({
                availableOrganizations: selectedOrg.length === 0 ? new Set(filterState.organization) : new Set(),
                availableCollections: selectedCol.length === 0 ? new Set(filterState.collection) : new Set(),
                availableTypes: selectedType.length === 0 ? new Set(filterState.type) : new Set(),
                availableSex: selectedSex.length === 0 ? new Set(filterState.sex) : new Set()
            });
            return;
        }

        if (selectedOrg.length) params.set('organization', selectedOrg.join(','));
        if (selectedCol.length) params.set('collection', selectedCol.join(','));
        if (selectedType.length) params.set('type', selectedType.join(','));
        if (selectedSex.length) params.set('sex', selectedSex.join(','));

        fetch(`${process.env.REACT_APP_BACK_END}/filters/?${params}`)
            .then(r => r.json())
            .then(data => {
                this.setState({
                    availableOrganizations: new Set(data.organizations || []),
                    availableCollections: new Set(data.collections || []),
                    availableTypes: new Set(data.types || []),
                    availableSex: new Set(data.sex || [])
                });
            })
            .catch(error => {
                console.error('Error fetching available filters:', error);
            });
    }

    componentDidMount() {
        const headers = {'Access-Control-Request-Method': 'GET'}
        const params = new URLSearchParams({full: 'true'});
        this.handleFetch(`${process.env.REACT_APP_BACK_END}/assays/?${params.toString()}`, {headers}, true);
    }

    createNewRequest = (input) => {
        // If any required filter is empty, show "no results" without making request
        if (!input.organization_input || !input.collection_input ||
            !input.type_input || !input.sex_input) {
            this.setState({
                response: 'assays_zero',
                status_code: 200,
                isLoading: false
            });
            return;
        }

        const headers = {'Content-Type': 'application/json'}
        const params = new URLSearchParams({
            type: input.type_input,
            collection: input.collection_input,
            organization: input.organization_input,
            sex: input.sex_input,
            age_min: input.age[0],
            age_max: input.age[1],
            age_na: input.age_settings_input.includes('age_na'),
            age_nb: input.age_settings_input.includes('age_nb')
        });
        this.handleFetch(`${process.env.REACT_APP_BACK_END}/assays/?${params.toString()}`, {headers});

    }

    handleFetch = (url, options, isInitial = false) => {
        this.setState({isLoading: true});
        fetch(url, options)
            .then(response => {
                this.setState({status_code: response.status})
                return response.text()
            })
            .then(data => {
                const newState = {response: data, isLoading: false};

                // Only initialize checkeds on initial load
                if (isInitial) {
                    try {
                        const parsed = JSON.parse(data);
                        const selectors = parsed.selectors || {};
                        const lists = {};
                        const checkeds = {};

                        lists['age_settings_list'] = ['age_na', 'age_nb'];
                        checkeds['age_settings_list'] = [true, true];

                        for (const s_name of this.state.selector_names) {
                            const list = selectors[s_name] || [];
                            lists[s_name] = list;
                            checkeds[s_name] = Array(list.length).fill(true);
                        }

                        newState.lists = lists;
                        newState.checkeds = checkeds;
                        newState.isInitialLoad = false;

                        // Initially all items are available
                        newState.availableOrganizations = new Set(lists['organization_list'] || []);
                        newState.availableCollections = new Set(lists['collection_list'] || []);
                        newState.availableTypes = new Set(lists['type_list'] || []);
                        newState.availableSex = new Set(lists['sex_list'] || []);
                    } catch (e) {
                        console.error('Error parsing initial response:', e);
                    }
                }

                this.setState(newState);
            })
            .catch(error => this.setState({status_code: 500, response: error.message, isLoading: false}));
    }

    renderPageHeader = () => (
        <div className="page-header mb-4">
            <h1 className="page-title">
                <FiDatabase size={28} />
                {i18n.t('assays_title')}
            </h1>
            <p className="page-description">{i18n.t('assays_description')}</p>
        </div>
    )

    render() {
        const {response} = this.state
        const {status_code} = this.state
        let {lists} = this.state
        let {checkeds} = this.state
        const {selector_names} = this.state
        const {headers} = this.state
        const {fields} = this.state
        const {functions} = this.state
        const {isLoading} = this.state

        const htmls = []
        let tableRows = []
        let tableHeaders = []
        let L = 0
        const ERRORS = ["assays_zero", "patients_zero", "organizations_zero", "collections_zero", "merge_zero"]

        const { availableOrganizations, availableCollections, availableTypes, availableSex } = this.state;

        // Helper to render AssayInput with default/current props
        const renderAssayInput = (overrides = {}) => (
            <AssayInput createNewRequest={this.createNewRequest}
                        onFilterChange={this.fetchAvailableFilters}
                        organization={overrides.organization || lists['organization_list'] || []}
                        organization_checked={overrides.organization_checked || checkeds['organization_list'] || []}
                        collection={overrides.collection || lists['collection_list'] || []}
                        collection_checked={overrides.collection_checked || checkeds['collection_list'] || []}
                        type={overrides.type || lists['type_list'] || []}
                        type_checked={overrides.type_checked || checkeds['type_list'] || []}
                        sex={overrides.sex || lists['sex_list'] || []}
                        sex_checked={overrides.sex_checked || checkeds['sex_list'] || []}
                        age_settings={overrides.age_settings || lists['age_settings_list'] || ['age_na', 'age_nb']}
                        age_settings_checked={overrides.age_settings_checked || checkeds['age_settings_list'] || [true, true]}
                        length_objects={overrides.length_objects !== undefined ? overrides.length_objects : L}
                        availableOrganizations={availableOrganizations}
                        availableCollections={availableCollections}
                        availableTypes={availableTypes}
                        availableSex={availableSex}
            />
        );

        if (isLoading) {
            return (<div className="main-container container">
                {this.renderPageHeader()}
                <div className="row">
                    <div className="col-4">
                        {renderAssayInput({ length_objects: 0 })}
                    </div>
                    <div className="col-8">
                        <LoadingSpinner message="loading_data" size="md" />
                    </div>
                </div>
            </div>);
        }

        if (status_code !== 200) {
            const errorType = status_code >= 500 ? 'error_server' : 'error_network';
            return (<div className="main-container container">
                {this.renderPageHeader()}
                <div className="row">
                    <div className="col-4">
                        {renderAssayInput({ length_objects: 0 })}
                    </div>
                    <div className="col-8">
                        <ErrorMessage
                            type="error"
                            message={errorType}
                            details={`Status: ${status_code}`}
                            onRetry={() => this.componentDidMount()}
                        />
                    </div>
                </div>
            </div>);
        }

        if (ERRORS.includes(response)) {
            return (<div className="main-container container">
                {this.renderPageHeader()}
                <div className="row">
                    <div className="col-4">
                        {renderAssayInput({ length_objects: 0 })}
                    </div>
                    <div className="col-8">
                        <Accordion>
                            <Accordion.Item
                                title={i18n.t("found_assays")}
                                badge={0}
                                defaultOpen={true}
                            >
                                <p className="empty-state">
                                    {i18n.t("no_results_found")}
                                </p>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                </div>
            </div>);
        }

        // Success case
        if (status_code === 200 && !ERRORS.includes(response)) {
            const parsed_json = JSON.parse(response)


            const assays = parsed_json["assays"]
            let table_json = parsed_json["table_json"]


            if (typeof assays !== 'undefined') {
                for (const i in fields) {
                    let chart = null
                    if (fields[i] !== "age") {
                        chart = functions[i](assays[fields[i]], i18n.t(headers[i]), `${fields[i]}_`)
                    } else {
                        chart = functions[i](assays[fields[i]], i18n.t(headers[i]), "")
                    }
                    htmls.push(
                        <Accordion.Item
                            key={`chart-${i}`}
                            title={i18n.t(headers[i])}
                            defaultOpen={true}
                        >
                            {chart}
                        </Accordion.Item>
                    )
                }
            }

            if (typeof table_json !== 'undefined') {
                table_json = JSON.parse(table_json)
                //Get the headers from JSON data
                const theaders = ["filter_organization", "filter_collection","diagnosis", "filter_type", "n"];
                tableHeaders = theaders.map((header) => (
                    <th key={header}>{i18n.t(header)}</th>
                ));

                for (let i = 0; i < table_json.length; i++) {
                    const cur_row = table_json[i]
                    const cur_organization = cur_row['organization']
                    const cur_collections = cur_row['collection']

                    // Calculate org_span as total number of type rows across all collections
                    const org_span = cur_collections.reduce((sum, col) => {
                        const types = col['type'] || [];
                        return sum + (types.length > 0 ? types.length : 1);
                    }, 0);

                    let orgCellRendered = false

                    for (let j = 0; j < cur_collections.length; j++) {
                        const cur_collection_row = cur_collections[j]
                        const cur_collection = cur_collection_row['collection']
                        const cur_types = cur_collection_row['type'] || []
                        // Calculate collection_span as number of type rows (minimum 1)
                        const collection_span = cur_types.length > 0 ? cur_types.length : 1
                        let collectionCellRendered = false

                        if (cur_types.length === 0) {
                            const cells = []
                            if (!orgCellRendered) {
                                cells.push(
                                    <td key={`org-${i}`} rowSpan={org_span}>
                                        {i18n.t("organization_" + cur_organization)}
                                    </td>
                                )
                                orgCellRendered = true
                            }
                            if (!collectionCellRendered) {
                                cells.push(
                                    <td key={`col-${i}-${j}`} rowSpan={collection_span}>
                                        {i18n.t("collection_" + cur_collection)}
                                    </td>
                                )
                                cells.push(
                                    <td key={`diag-${i}-${j}`} rowSpan={collection_span}></td>
                                )
                                collectionCellRendered = true
                            }
                            cells.push(<td key={`type-${i}-${j}-empty`}></td>)
                            cells.push(<td key={`n-${i}-${j}-empty`}></td>)
                            tableRows.push(<tr key={`row-${i}-${j}-empty`}>{cells}</tr>)
                            continue
                        }

                        for (let k = 0; k < cur_types.length; k++) {
                            const cur_type_row = cur_types[k]
                            const cells = []

                            if (!orgCellRendered) {
                                cells.push(
                                    <td key={`org-${i}`} rowSpan={org_span}>
                                        {i18n.t("organization_" + cur_organization)}
                                    </td>
                                )
                                orgCellRendered = true
                            }

                            if (!collectionCellRendered) {
                                cells.push(
                                    <td key={`col-${i}-${j}`} rowSpan={collection_span}>
                                        {i18n.t("collection_" + cur_collection)}
                                    </td>
                                )
                                cells.push(
                                    <td key={`diag-${i}-${j}`} rowSpan={collection_span}></td>
                                )
                                collectionCellRendered = true
                            }

                            cells.push(
                                <td key={`type-${i}-${j}-${k}`}>
                                    {i18n.t("type_" + cur_type_row['type'])}
                                </td>
                            )
                            cells.push(<td key={`n-${i}-${j}-${k}`}>{cur_type_row['n']}</td>)
                            tableRows.push(<tr key={`row-${i}-${j}-${k}`}>{cells}</tr>)
                        }
                    }
                }
            }

            L = parsed_json['assay_n'];
        }

        return (<div className="main-container container">
            {this.renderPageHeader()}
            <div className="row">
                <div className="col-4">
                    {renderAssayInput()}
                </div>
                <div className="col-8">
                    <Accordion>
                        <Accordion.Item
                            title={i18n.t("found_assays")}
                            badge={L}
                            defaultOpen={true}
                        >
                            <div className="table-responsive modern-table-container">
                                <table id="display_json_data" className="table table-hover modern-table">
                                    <thead>
                                        <tr>{tableHeaders}</tr>
                                    </thead>
                                    <tbody>{tableRows}</tbody>
                                </table>
                            </div>
                        </Accordion.Item>
                        {htmls}
                    </Accordion>
                </div>
            </div>
        </div>);
    }

}
